function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.5,
  fill: "white",
  stroke: "#636776"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4253 6.63176C11.152 6.63176 11.7411 6.04262 11.7411 5.31588C11.7411 4.58914 11.152 4 10.4253 4C9.69852 4 9.10938 4.58914 9.10938 5.31588C9.10938 6.04262 9.69852 6.63176 10.4253 6.63176Z",
  fill: "#636776"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.74259 10.6302C7.74259 10.6302 6.93282 9.82045 8.2487 8.80823C9.56458 7.79602 10.3237 7.72516 10.8096 8.2009C11.6396 9.04104 9.77714 12.5636 9.71641 13.2417C9.65568 13.9199 9.74678 14.0211 9.80751 14.1224C9.86824 14.2236 11.093 13.1405 11.093 13.1405L11.7307 13.8491C11.7307 13.8491 10.6072 15.0637 9.91885 15.3168C9.23055 15.5698 8.63334 15.8027 8.16772 15.3168C7.7021 14.8309 7.82357 13.9908 8.10699 13.2316C8.39041 12.4725 9.07871 10.1747 9.10908 9.92167C9.13945 9.66862 8.97749 9.53703 8.71432 9.76984C8.3398 10.1039 7.74259 10.6302 7.74259 10.6302Z",
  fill: "#636776"
});

var SvgInformation = function SvgInformation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInformation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/information.bb91fd75.svg";
export { ForwardRef as ReactComponent };